"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_USER_ALARM_COLORS = void 0;
exports.DEFAULT_USER_ALARM_COLORS = {
    notDefined: "#ffffff",
    noData: "#c0c0c0",
    normal: "#66bb6a",
    attention: "#ffeb3b",
    warning: "#ff9800",
    alarm: "#f44336",
    invalid: "#ff00ff",
    pickupFailed: "#0000ff",
};
//# sourceMappingURL=alarm-colors.js.map